<template>
    <div v-loading="loadingContent">
         
        <h1>eSocial - Download de Arquivo</h1>
        <div class="widget-container fluid-height clearfix widget-content padded">

            <div class="form-group col-md-12" v-if="error">
                <div class="col-md-12">
                    <el-alert
                        title="Atenção"
                        type="error"
                        :description="error"
                        show-icon
                        :closable="false"
                        >
                    </el-alert>
                </div>
            </div>

            <div class="form-group col-md-12" v-if="!error && formData.id">

                <div class="col-md-12" style="padding:0px">
                    <el-alert
                        title="Arquivo Carregado com Sucesso"
                        type="success"
                        description="Confira abaixo as informações do lote"
                        show-icon
                        :closable="false"
                        >
                    </el-alert>
                </div>

                <div class="form-group col-md-12"><br></div>

                <div class="col-md-2" style="border-bottom:solid 1px #ccc"><b>Lote:</b></div>
                <div class="col-md-10" style="border-bottom:solid 1px #ccc">{{formData.lote}}</div>

                <div class="col-md-2" style="border-bottom:solid 1px #ccc"><b>Empresa:</b></div>
                <div class="col-md-10" style="border-bottom:solid 1px #ccc">{{formData.empresa_nome_fantasia}} - {{formData.empresa_cnpj}}</div>

                <div class="col-md-2" style="border-bottom:solid 1px #ccc"><b>Layout:</b></div>
                <div class="col-md-10" style="border-bottom:solid 1px #ccc">{{formData.layout}}</div>

                <div class="col-md-2" style="border-bottom:solid 1px #ccc"><b>Nome do Arquivo:</b></div>
                <div class="col-md-10" style="border-bottom:solid 1px #ccc"><a href="#" @click="onDownloadArquivo">{{formData.filename}}</a></div>

                <div class="col-md-2" style="border-bottom:solid 1px #ccc"><b>Última Atualização:</b></div>
                <div class="col-md-10" style="border-bottom:solid 1px #ccc">{{toDate(formData.updated_at,false)}}</div>

                <div class="form-group col-md-12 text-center" style="margin-top:50px">

                    <el-button type="primary"
                      size="large" 
                      style="width:190px"
                      :loading="loadingDownload"
                      @click="onDownloadArquivo"
                    >
                        <i v-if="!loadingDownload" class="fa fa-download"></i>
                        Baixar Arquivo
                    </el-button>

                    <div class="form-group col-md-12 text-center" style="margin-top:30px;color:red">
                        <i class="fa fa-info-circle"></i>
                        O arquivo foi baixado automaticamente. Clique no botão acima para baixar novamente.
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>

    import Rest from 'common/rest'
    import Fct from 'common/fct'
    
    export default {
        name:"esocial-lotes",
        mixins:[Rest],
        components:{},
        data () {
          return {
            loadingContent:true,
            loadingDownload:false,
            error:null,
            formData:{
            }
          }
        },

        created(){
            $('.carregando').hide();
        },

        mounted() {
            this.getEsocialLote();
        },

        methods:{

          toDate: function(data,disableHours){
            return Fct.toDate(data,disableHours);
          },

          getEsocialLote: function(){

            this.loadingContent = true;
            this.loadingDownload = true;
            this.error = null;

            var _email = (this.$route.params.email ? this.$route.params.email : null);
            
            this.get('/util/esocial/arquivo/'+this.$route.params.link,{email:_email}).then((result)=>{

                result = result[0];

                this.loadingContent = false;

                if(result.status == 200){
                    this.formData = result.data;
                    this.onDownloadArquivo();
                }
                else{
                    this.error = result.msg;
                }
            });
          },

          onDownloadArquivo: function(){

            this.loadingDownload = false;

            if(this.formData.contents){

                var contents = this.formData.contents;
                var filename = this.formData.filename;
                var contentType = this.formData.contentType;

                var blob = Fct.b64toBlob(contents,contentType);

                Fct.download(blob,filename);

                this.getEsocialLotes();
            }
            else{

              this.$alert('Não foi possível baixar o arquivo', 'Atenção', {
                  confirmButtonText: 'OK',
                  type:'info'
              });

            }
          }

        }
    }
</script>



// WEBPACK FOOTER //
// download.vue?093ba29d